<template>
  <div class="back-top" :class="{ 'back-top--active': show }" @click="backTop">
    <div class="back-top--btn"></div>
  </div>
</template>

<script>
export default {
  name: 'BackTop',
  data() {
    return {
      top: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrolling)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrolling)
  },
  computed: {
    show() {
      return this.top > window.screen.height
    }
  },
  methods: {
    handleScrolling() {
      this.top = document.documentElement.scrollTop || document.body.scrollTop
    },
    backTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
.back-top {
  position: fixed;
  width: 45px;
  height: 45px;
  bottom: 20px;
  right: 10px;
  transition: opacity 0.15s ease-in;
  opacity: 0;

  &--active {
    opacity: 1;
  }

  &--btn {
    height: 100%;
    background-image: url('~@/assets/images/rocket.png');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 100%;
  }
}
</style>
